import { Grid, FormControl, Autocomplete, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

const SelectAutoComplete = ({ name, label, size=12, options = [], val="" }) =>{
    const { control } = useFormContext();
    const defaultValue = () => val ? options.find(o => Object.values(o)[0] === val) : ''
    if(!options.length) return;
    
    return(
        <Grid item xs={12} sm={12} md={size}>
            <FormControl fullWidth>
                <Controller
                    name={name}
                    control={control}
                    rules={{ required: 'Debes seleccionar una opción' }}
                    render={({ field: { ref, onChange }, fieldState: { invalid, error } }) => (
                        <Autocomplete
                            freeSolo
                            options={options}
                            getOptionLabel={(option) => Object.values(option)[1] ? Object.values(option)[1] : ''}
                            onChange={(_, data) => onChange(data ? Object.values(data)[0] : val)}
                            defaultValue={defaultValue}
                            renderInput={(params) => (
                                <TextField
                                    name={name}
                                    {...params}
                                    error={invalid}
                                    margin="normal"
                                    fullWidth
                                    inputRef={ref}
                                    variant="outlined"
                                    label={label}
                                    helperText={error && error.message}
                                />
                            )}
                        />
                    )}
                />
            </FormControl>
        </Grid>
    )
}

export default SelectAutoComplete;